<template>
  <div class="icon_buttons" :class="[ !showPanel.isLeftPanel ? 'vertical' : 'horizon' ]">
    <template v-if="accessedMemberInfo.name">
      <button
        v-if="showPanel.isLeftPanel" type="button"
        :class="{ 'account_btn' : showPanel.isAccountInfo }"
        :disabled="disabledQualification()"
        @click="showAccountToggle"
      >
        <span>
          <AccountSvg />
        </span>
        ACCOUNT
      </button>
      <button
        type="button" :disabled="disabledQualification()"
        @click="submitLogout"
      >
        <span>
          <LogoutSvg />
        </span>
        LOGOUT
      </button>
    </template>
    <button
      type="button"
      :disabled="disabledQualification()"
      @click="imageModeToggle"
    >
      <span>
        <ImageModeSvg />
      </span>
      IMAGE MODE
    </button>
    <button
      v-if="showPanel.isLeftPanel" type="button"
      :disabled="disabledQualification()"
      @click="hideLeftPanel"
    >
      <span>
        <HideSvg />
      </span>
      HIDE
    </button>
    <button
      v-else type="button"
      :disabled="disabledQualification()"
      @click="showLeftPanel"
    >
      <span>
        <OpenSvg />
      </span>
      OPEN
    </button>
  </div>
</template>

<script lang="ts" setup>
import AccountSvg from '@/assets/images/Svgs/AccountSvg.vue';
import HideSvg from '@/assets/images/Svgs/HideSvg.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import LogoutSvg from '@/assets/images/Svgs/LogoutSvg.vue';
import OpenSvg from '@/assets/images/Svgs/OpenSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';

const {
  hideLeftPanel,
  showLeftPanel,
  showAccountToggle,
  imageModeToggle,
  disabledQualification,
  showPanel,
} = useCommonStore();
const { accessedMemberInfo, accessLogout } = useMemberStore();

/**
 * 로그아웃 기능을 실행합니다.
 */
const submitLogout = (): void => {
  accessLogout();

  if (!showPanel.isLeftPanel) {
    showLeftPanel();
  }

  if (showPanel.isEditPassword) {
    showPanel.isEditPassword = false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.icon_buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 13.2px 0 33.7px;
  position: absolute;

  button {
    width: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 3.8px;
    font-size: 8px;
    fill: $color-white;
    color: $color-white;

    span {
      display: flex;
      align-items: center;
      height: 100%;
    }

    &.account_btn {
      fill: $color-debra;
      color: $color-debra;
    }
  }

  &.vertical {
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 35px;
  }

  &.horizon {
    flex-direction: row;
    left: 50%;
    transform: translateX(-50%);
    bottom: 2px;

    &.mobile {
      button {
        width: 50px;
      }
    }
  }
}
</style>